import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Center, Box, Stack } from '@chakra-ui/react';
import { useLanguage } from './languageContext';
import LanguageSwitch from './LanguageSwitch';

const FormMenu = ({ isSmallScreen }) => {
  const { language, toggleLanguage } = useLanguage();
  return (
    <Center bg="#f8f8f8">
      <Box textAlign="center">
        <Stack
          direction={{ base: "column", md: "row" }}
          spacing={{ base: 4, md: 6 }}
          align={{ base: "center", md: "flex-start" }}
          width={{ base: "60%", md: "80%", lg: "100%" }}
          mx="auto"
        >
          <Button
            as={Link}
            to="/flora"
            variant="link"
            size={{ base: "sm", md: "sm" }}
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word", // Allow content to wrap into multiple lines
              height: "50px",
            }}
          >
            {isSmallScreen
              ? "Flora"
              : language === "english" ? "Upload Flora Data" : "Subir Datos de Flora"}
          </Button>
          <Button
            as={Link}
            to="/fauna"
            variant="link"
            size={{ base: "sm", md: "sm" }}
            style={{
              whiteSpace: "normal", // Allow text to wrap onto multiple lines
              height: "50px", // Let the height adjust based on content
            }}
          >
            {isSmallScreen
              ? "Fuana"
              : language === "english" ? "Upload Fauna Data" : "Subir Datos de Fauna"}
          </Button>
          <Button
            as={Link}
            to="/image"
            variant="link"
            size={{ base: "sm", md: "sm" }}
            style={{
              whiteSpace: "normal", // Allow text to wrap onto multiple lines
              height: "50px", // Let the height adjust based on content
            }}
          >
            {isSmallScreen
              ? language === "english" ? "Image": "Imagen"
              : language === "english" ? "Upload Image" : "Subir Imagen"}
          </Button>

        </Stack>
      </Box>
    </Center>
  );
};

export default FormMenu;